<template>
  <v-btn
    :id="id"
    :color="tipo"
    @click.stop="onclick"
    class="boton"
    slot="activator"
    :disabled="deshabilitado"
    :small="small"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'Boton',
  props: {
    id: {
      type: String
    },
    tipo: {
      type: String,
      default: 'warning'
    },
    onclick: {
      type: [Object, Function, Boolean],
      default: () => () => {}
    },
    deshabilitado: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import 'src/resources/styles/variables.scss';
.boton {
  font-weight: 600 !important;
  color: $color-text-primary !important;
}
</style>
